app.service('productAccessories', function (productCardConfig, cartManager, store) {
	let config;
	let $self, $accessoriesGroups, $accessoriesList, $tabSection;

	function init() {
		config = productCardConfig.getData();
		$self = $("#product-accessories");
		$tabSection = $("[data-section-id=akcesoria]");
		setElements();
		setEvents();
		renderAccessories();
		store.onChange(toggleAccessoriesTab);
	}

	function fetchAccessories(groupId) {
		$self.addClass('loading');

		const data = {
			'product-link-name': config.linkName,
			'group-id': groupId
		};

		return $.ajax({
			url: '/product-card-accessory.ltr',
			data: data,
			success: (html) => {
				renderAccessories(html);
			},
			error: () => {
				$accessoriesList.html('Wystąpił błąd ładowania zakładki Akcesoria');
			},
			complete: () => {
				$self.removeClass('loading');
			}
		});
	}

	function renderAccessories(html) {
		if(html) {
			$accessoriesList.html(html);
		}

		$self.productSlider();
		checkCart();
	}

	function checkCart() {
		cartManager.checkRelatedProducts();
	}

	function addToCartClick() {
		const id = $(this).val();
		const checked = $(this).is(':checked');
		cartManager.clickRelatedProducts(id, checked,'ACCESS_CARD', config.plu);
	}

	function selectNewGroup(group) {
		$accessoriesGroups.find('.active').toggleClass('active inactive');
		$accessoriesGroups.find('[data-group='+group+']').toggleClass('active inactive');
	}

	function showMoreCategories() {
		$self.addClass('show-all-categories');
	}

	function setElements() {
		$accessoriesGroups = $(".accessories-groups", $self);
		$accessoriesList = $(".accessories-list", $self);
	}

	function setEvents() {
		$self.on('click', '.js-category-access', handleChangeGroup);
		$self.on('click','.js-category-access-more', showMoreCategories);
		$self.on('click', '.js-add-accessory-to-cart-checkbox', addToCartClick);
		$(document).on('cartReady', checkCart);
	}

	function handleChangeGroup(e) {
		const $categoryBtn = $(e.target);
		if($categoryBtn.hasClass('active')) return;

		let groupId = $categoryBtn.data('group');
		fetchAccessories(groupId);
		selectNewGroup(groupId);
	}

	function toggleAccessoriesTab() {
		store.data.isOutlet ?
			$tabSection.addClass('is-hidden') :
			$tabSection.removeClass('is-hidden');
	}


	return {
		init
	};
});